import React from "react";
import { useScrollAnimation } from "../hooks/useScrollAnimation";

const reasons = [
  { icon: "⚡", title: "Fast Communication", desc: "We respond within hours — not days. Your time matters as much as ours.", iconBg: "bg-blue-100" },
  { icon: "🧩", title: "Multi-Service Company", desc: "Web, design, video, ads — all under one roof. No juggling multiple vendors.", iconBg: "bg-indigo-100" },
  { icon: "📈", title: "Business-Focused Approach", desc: "We don't just design — we think about your revenue, leads, and growth.", iconBg: "bg-green-100" },
  { icon: "🛠️", title: "Custom Solutions", desc: "Zero templates. Everything is built specifically for your brand and goals.", iconBg: "bg-yellow-100" },
  { icon: "🤝", title: "Long-Term Support", desc: "We stay after delivery — updates, fixes, and growth support always available.", iconBg: "bg-pink-100" },
  { icon: "🌍", title: "Global & Local Expertise", desc: "We've worked with Indian startups and international clients across industries.", iconBg: "bg-teal-100" },
];

export default function WhyUs() {
  const ref = useScrollAnimation();

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&family=Fraunces:wght@700;900&display=swap');
        .why-heading { font-family: 'Fraunces', serif; }
        .why-body { font-family: 'Plus Jakarta Sans', sans-serif; }
      `}</style>

      <section id="about" className="why-body py-20 relative bg-gradient-to-b from-white to-blue-50 overflow-hidden">
        {/* Blobs */}
        <div className="absolute top-0 right-0 w-72 h-72 bg-blue-100/50 rounded-full blur-3xl pointer-events-none" />
        <div className="absolute bottom-0 left-0 w-80 h-80 bg-sky-100/40 rounded-full blur-3xl pointer-events-none" />

        <div className="max-w-7xl mx-auto px-5 md:px-10 relative">
          <div ref={ref} className="section-animate flex flex-col lg:flex-row gap-14 items-center">

            {/* Left */}
            <div className="lg:w-2/5 flex-shrink-0">
              <span className="inline-block text-xs font-bold text-blue-600 tracking-widest uppercase bg-blue-100 border border-blue-200  px-5 py-1.5 mb-5">
                Why Nosh Infotech
              </span>
              <h2 className="why-heading font-black text-4xl md:text-5xl text-black mb-5 leading-tight">
                Why Clients{" "}
                <span style={{ background: "linear-gradient(135deg,#1d4ed8 0%,#0ea5e9 100%)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", backgroundClip: "text" }}>
                  Choose Us
                </span>
              </h2>
              <p className="text-slate-500 text-base leading-relaxed font-medium mb-8">
                We're not just another agency. We are your dedicated digital team — obsessed with quality, speed, and your success.
              </p>
              <a
                href="#contact"
                className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white font-bold text-sm px-7 py-3.5 rounded transition-all duration-300 hover:scale-105 shadow-lg shadow-blue-200"
              >
                Start a Project →
              </a>
            </div>

            {/* Right grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 w-full">
              {reasons.map((r, i) => (
                <div
                  key={i}
                  className="group relative bg-white border border-slate-200 rounded p-5 flex gap-4 items-start shadow-sm hover:shadow-lg hover:shadow-blue-100 hover:-translate-y-1 transition-all duration-300 overflow-hidden"
                >
                  <div className={`w-10 h-10 rounded ${r.iconBg} flex items-center justify-center flex-shrink-0 text-xl group-hover:scale-110 transition-transform duration-300`}>
                    {r.icon}
                  </div>
                  <div>
                    <h3 className="why-heading font-bold text-black text-sm mb-1">{r.title}</h3>
                    <p className="text-slate-500 text-xs leading-relaxed font-medium">{r.desc}</p>
                  </div>
                  {/* Accent line */}
                  <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-gradient-to-r from-blue-400 to-sky-400 scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left rounded" />
                </div>
              ))}
            </div>

          </div>
        </div>
      </section>
    </>
  );
}